import React, { useEffect, useState } from "react";
import { Grid, Paper, Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DashboardSection from "./DashboardSection";
import StatementLink from "../shared/StatementLink";
import PopularIcon from "./svg/icon-popular.svg";
import StatementsList, { StatusType } from "./StatementsList";
import { initStatementNavigation } from "../statements/statementNavigation";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../firebase/AuthProvider";
import { colors } from "../../theme";
import Button from "../shared/Button";
import {
  StatementPopular,
  getStatementsPopular,
  mapToListItem,
} from "../../firebase/statementspopular";

const useStyles = makeStyles((theme) => ({
  container: {
  },
  statementTitle: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.67,
    letterSpacing: "-0.05px",
    color: colors.TEXT_PRIMARY,
    "&:hover": {},
  },
  textOverflow: {
    marginTop: "32px",
    height: "235px",
    // textOverflow: "ellipsis",
    //   overflow: "hidden",
    //   whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      height: "40px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "250px",
    },
  },
  viewButton: {
    [theme.breakpoints.down("xs")]: {
      width: "66px",
      marginBottom: "35px",
      marginTop: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "66px",
    },
  },
}));

export default function PopularStatements() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { user } = useAuth();
  const [status, setStatus] = useState<StatusType>("idle");
  const [statementsPopular, setStatementsPopular] = useState<
    StatementPopular[]
  >([]);

  useEffect(() => {
    async function fetchStatementsPopular() {
      setStatus("loading");
      const statements = await getStatementsPopular();

      if (statements.length === 0) setStatus("nothing_found");
      else setStatus("done");

      setStatementsPopular(statements);
    }
    fetchStatementsPopular();
  }, [user]);

  function handleStatementClick() {
    initStatementNavigation(statements.map((s) => s.slug));
  }

  const statements = statementsPopular.map(mapToListItem);
  return (
    <>
      <Hidden lgUp>
        <StatementsList statements={statements} status={status}>
          <Grid container item>
            <DashboardSection
              title={t("dashboard_statements.popular")}
              icon={PopularIcon}
            />
          </Grid>
        </StatementsList>
      </Hidden>
      <Hidden mdDown>
        <Grid container item style={{ paddingBottom: "24px" }}>
          <DashboardSection
            title={t("dashboard_statements.popular")}
            icon={PopularIcon}
          />
        </Grid>
        <Grid container xs={12} item spacing={2} style={{ paddingBottom: "24px" }}>
            <Grid container sm={1} xs={1} item spacing={2} />
            <Grid container sm={10} xs={11} item spacing={2}>
                {statements.map((statement) => (
                  <Grid item xs={12} sm={4} className={classes.container} container key={statement.id}>
                    <Grid container item xs={12} sm={11}>
                        <Grid container xs={11} item spacing={2}>
                          <Paper
                              style={{
                                backgroundImage: `url(${statement.imgUrl})`,
                                width: "100%",
                                height: "200px",
                                borderRadius: "10px",
                                backgroundSize: "cover",
                              }}
                            />
                        </Grid>
                        <Grid container item xs={11} sm={12}>
                          <div className={classes.textOverflow}>
                            <StatementLink
                              slug={statement.slug}
                              className={classes.statementTitle}
                              onClick={handleStatementClick}
                            >
                              {statement.title}
                            </StatementLink>
                          </div>
                        </Grid>
                        <Grid item xs={11} sm={12}>
                          <Button
                            linkTo={statement.slug}
                            className={classes.viewButton}
                            onClick={handleStatementClick}
                          >
                            View
                          </Button>
                        </Grid>
                      </Grid>
                  </Grid>
                ))}
            </Grid>
            <Hidden xsDown>
              <Grid container sm={1} item spacing={2} />
            </Hidden>
        </Grid>
      </Hidden>
    </>
  );
}
